import React, { useMemo } from "react";
import { Dialog, GridGenerator } from "@actinc/dls";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useForm } from "react-hook-form";

import { ControlledFormSelect } from "..";

const CompleteTasksDialog = ({
  onClose,
  open,
  taskIDs,
  types,
  ...completion
}) => {
  const handleClose = (value) => () => {
    onClose(value);
  };

  const buttonOrder = useMemo(() => {
    return [...completion.options].reverse();
  }, [completion.options]);
  const objects = useMemo(
    () =>
      types
        .map((type) => (taskIDs.length > 1 ? `${type}s` : type))
        .join(" and "),
    [types]
  );

  const buttonSX = [
    { color: "primary", variant: "contained" },
    { color: "secondary", variant: "outlined" },
    { color: "warning", variant: "outlined" },
    { color: "warning", variant: "text" },
  ];

  return (
    <Dialog maxWidth="sm" onClose={handleClose(false)} open={open}>
      <DialogTitle>Complete Task{taskIDs.length > 1 && "s"}</DialogTitle>
      <DialogContent>
        <List>
          {completion.options.map((option) => (
            <ListItem key={option.buttonLabel}>
              <ListItemText>
                {option.developmentState &&
                  `${option.buttonLabel} will send the ${objects} to ${option.developmentState}.`}
                {!option.developmentState &&
                  option.taskDefinition &&
                  `${option.buttonLabel} will create ${
                    taskIDs.length > 1 ? "" : "a "
                  }${option.taskDefinition.key} task${
                    taskIDs.length > 1 ? "s" : ""
                  } for the ${objects}.`}
                {!option.developmentState &&
                  !option.taskDefinition &&
                  `${option.buttonLabel} will complete the selected task${
                    taskIDs.length > 1 ? "s" : ""
                  }.`}
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose(false)} variant="text">
          Cancel
        </Button>
        {buttonOrder.map((option, index) => {
          return (
            <Button
              {...buttonSX.at(buttonOrder.length - (index + 1))}
              form="completeTasksForm"
              key={option.buttonLabel}
              onClick={handleClose(option)}
              type="button"
            >
              {option.buttonLabel}
            </Button>
          );
        })}
      </DialogActions>
    </Dialog>
  );
};

export { CompleteTasksDialog };
